import request from '@/utils/request'
import trace from '@/utils/trace'
// 用户相关API
export const userApi = {
  // 入口统计
  prepare(data) {
    return request({
      url: '/am/api/am/command/v2/prepare',
      method: 'post',
      data
    })
  },
  //获取token
  generateToken(data) {
    return request({
      url: '/am/api/am/command/v2/generateToken',
      method: 'post',
      data
    })
  },
  //传手机给后端
  register(data) {
    return request({
      url: '/uaa/api/app/auth/register',
      method: 'post',
      data
    })
  },
  getchannel(params) {
    return request({
      url: '/base/api/channel/getChannelEncryptionInfo',
      method: 'get',
      params
    })
  },
  //拉起微信安卓引导页
  evokeBroswer(params) {
    return request({
      url: '/am/api/associateMember/command/evokeBroswer',
      method: 'get',
      params
    })
  },

  //下单
  signOrder(data) {
    return request({
      url: '/am/api/am/command/encrypt/v2/signOrder',
      method: 'post',
      data
    })
  },
  //储存键值对
  saveFastAppUrl(data) {
    return request({
      url: '/base/api/fast/app/saveFastAppUrl',
      method: 'post',
      data
    })
  },
  //判断当前手机是否能走快应用（默认关闭）
  supportsFastApp(data) {
    return request({
      url: '/base/api/user/agent/supportsFastApp',
      method: 'post',
      data
    })
  },


  //判断当前手机是否能走快应用（默认开启）
  fcFast(data) {
    return request({
      url: '/base/api/user/agent/fengchaoSupportsFastApp',
      method: 'post',
      data
    })
  },
  //微信环境禁止分享
  getSignConfig(data) {
    return request({
      url: '/uaa/api/wechat/mp/getSignConfig',
      method: 'post',
      data
    })
  },
  //支付宝获取手机（生活号）
  authorizeMobile(data) {
    return request({
      url: '/uaa/api/alipay/life/user/authorizeMobile',
      method: 'post',
      data
    })
  },
  //流量统计
  statistics(data) {
    return request({
      url: '/am/api/sync/oldSystemData/syncFlowStatisticsData',
      method: 'post',
      data
    })
  },
  geturl(data) {
    return request({
      url: '/alternate/api/alternate/query/alternateProductInfo',
      method: 'post',
      data
    })
  },
  queryByCode(data) {
    return request({
      url: '/base/api/app/mapping/storage/queryByCode',
      method: 'post',
      data
    })
  },
  getAuditLink(data) {
    return request({
      url: '/base/api/productLinkConfig/getAuditLink',
      method: 'post',
      data
    })
  }














}

export const traceApi = {
  // 入口埋点
  click(data) {
    return trace({
      url: '/api/trace/data/click/saveOrUpdate',
      method: 'post',
      data
    })
  },
  event(data) {
    return trace({
      url: '/api/trace/data/event/saveOrUpdate',
      method: 'post',
      data
    })
  },



}

// 导出所有API
export default {
  userApi,
  traceApi
}